import axios, { AxiosResponse } from 'axios';
import api from './api';
import { ReviewFrequency } from './api';

/**
 * Fetches all review frequencies
 */
export const getAllReviewFrequencies = (): Promise<ReviewFrequency[]> => {
    return api.get('/review_frequencies')
        .then(response => response.data);
};

/**
 * Creates a new review frequency
 */
export const createReviewFrequency = (frequency: { 
    name: string; 
    display_label: string;
    description: string; 
}): Promise<ReviewFrequency> => {
    return api.post('/review_frequency', frequency)
        .then(response => response.data);
};

/**
 * Updates an existing review frequency
 */
export const updateReviewFrequency = (frequency: { 
    name: string;
    display_label?: string;
    description?: string; 
}): Promise<ReviewFrequency> => {
    return api.put('/review_frequency', frequency)
        .then(response => response.data);
};

/**
 * Deletes a review frequency by name
 */
export const deleteReviewFrequency = (name: string): Promise<void> => {
    return api.delete(`/review_frequency/${name}`)
        .then(response => response.data);
};
